import TrackContact from "@/components/TrackContact";
import { PAGE_META } from "@/lib/seo-constants";

export default function IndustrialContact() {
    return (
        <TrackContact
            trackKey="industrial"
            meta={PAGE_META.industrialContact}
            headline={
                <>
                    Engineered industrial
                    <br />
                    <span className="text-brand-coral">scopes & quotes.</span>
                </>
            }
            subhead="Send us your site and requirements. We respond within one business day with an engineered scope, quote, and the compliance documentation your facility needs."
        />
    );
}
